import { CATEGORY_OPTIONS } from "./constants";
import { formatLabel, toSnakeCase } from "./helpers";

interface FailDetailsProps {
  selectedCategories: Set<string>;
  details: Record<string, string | null>;
  severity: string | null;
  notes: string | null;
  onDetailChange: (category: string, detail: string | null) => void;
  onSeverityChange: (severity: string | null) => void;
  onNotesChange: (notes: string | null) => void;
}

const FailDetails: React.FC<FailDetailsProps> = ({
  selectedCategories,
  details,
  severity,
  notes,
  onDetailChange,
  onSeverityChange,
  onNotesChange
}) => {
  const categoriesWithOptions = [...selectedCategories].filter((cat) => CATEGORY_OPTIONS[cat]);
  const onlySubjective = selectedCategories.size === 1 && selectedCategories.has("subjective");

  return (
    <div className="fail-details open">
      {categoriesWithOptions.map((category) => (
        <div key={category} className="category-detail-section">
          <div className="cat-label">{formatLabel(category)}</div>
          <div className="fail-field">
            <label htmlFor={`ce-detail-${category}`}>Category</label>
            <select
              id={`ce-detail-${category}`}
              value={details[category] || ""}
              onChange={(e) => onDetailChange(category, e.target.value || null)}
            >
              <option value="">--</option>
              {CATEGORY_OPTIONS[category].map((opt) => (
                <option key={opt} value={toSnakeCase(opt)}>
                  {opt}
                </option>
              ))}
            </select>
          </div>
        </div>
      ))}

      {!onlySubjective && selectedCategories.size > 0 && (
        <div className="fail-field">
          <label htmlFor="ce-severity">Output Severity</label>
          <select id="ce-severity" value={severity || ""} onChange={(e) => onSeverityChange(e.target.value || null)}>
            <option value="">--</option>
            <option value="critical">Critical</option>
            <option value="moderate">Moderate</option>
            <option value="minor">Minor</option>
          </select>
        </div>
      )}

      {selectedCategories.size > 0 && (
        <div className="fail-field">
          <label htmlFor="ce-notes">Notes</label>
          <input
            id="ce-notes"
            type="text"
            value={notes || ""}
            onChange={(e) => onNotesChange(e.target.value || null)}
            placeholder="Optional notes..."
          />
        </div>
      )}
    </div>
  );
};

export default FailDetails;
